import React, { useEffect, useState } from 'react';
import { Route, Routes, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setUser, generateToken } from '../features/auth/authSlice';
import axios from 'axios';

function ProtectedRoutes() {
  const authState = useSelector(state => state.auth);
  const { isAuthenticated } = authState;
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
      console.log("Checking authentication status...");
      
      const checkAuth = async () => {
          try {
              const response = await axios({
                  method: 'POST',
                  url: process.env.API_URL + '/whoami',
                  withCredentials: true,
                  headers: {
                      'Content-Type': 'application/json'
                  }
              });
              
              console.log("Auth response:", response.data);
              
              if (response.data?.user?.nameID) {
                  await dispatch(generateToken({
                      email: response.data.user.nameID
                  }));
                  dispatch(setUser(response.data.user));
              } else {
                  console.log("No valid user data received");
                  redirectToLogin();
              }
          } catch (err) {
              console.error('Authentication check failed:', err);
              if (err.response?.status === 401) {
                  redirectToLogin();
              }
          } finally {
              setLoading(false);
          }
      };
      
      checkAuth();
  }, [dispatch]);

  const redirectToLogin = () => {
      console.log("Redirecting to login...");
      window.location.href = process.env.API_URL + '/login';
  };

  if (loading) {
      return <div>Loading...</div>;
  }

  return (
    <>
      {isAuthenticated ? <Outlet /> : <div>Authenticating...</div>}
        {/* <Outlet /> */}
    </>
  );
}

export default ProtectedRoutes;
